// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Card */
.card {
    margin-bottom: 30px;
    border: none;
    border-radius: 5px;
    box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);
  }
  
  .card-header,
  .card-footer {
    border-color: #ebeef4;
    background-color: #fff;
    color: #798eb3;
    padding: 15px;
  }
  
  .user-webnexs .card-title {
    padding: 20px 0 15px 0;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
    font-family: "Poppins", sans-serif;
  }

  .user-webnexs span.small.pt-1.fw-bold {
    color: black;
}
  
  .card-title span {
    color: #899bbd;
    font-size: 14px;
    font-weight: 400;
  }
  
  .card-body {
    padding: 0 20px 20px 20px;
  }
  
  .card-img-overlay {
    background-color: rgba(255, 255, 255, 0.6);
  }
  
  .dashboard .nav-link{
    border-radius: 5px;
    border-bottom: 1px solid #e9e6e6;
    font-weight: 500;
    color: #000000;
    background-color: #e1e1e1;
  }

  .dashboard .nav-link.active {
    background: rgb(255 255 255 / 20%);
    font-size: 16px;
    font-weight: 500;
    color: #000;
}

  .upload-video {background-color: #fafafa;
  padding: 10px;
  border-radius: 10px;}

  .iq-card {
    background: #fff;
    border-radius: 5px;
    margin-bottom: 30px;
    border: none;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 5%);
    border-radius: 5px;}

    `, "",{"version":3,"sources":["webpack://./src/Pages/ContactUs/Cache Management/ContactRequest.css"],"names":[],"mappings":";AACA,SAAS;AACT;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,4CAA4C;EAC9C;;EAEA;;IAEE,qBAAqB;IACrB,sBAAsB;IACtB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kCAAkC;EACpC;;EAEA;IACE,YAAY;AAChB;;EAEE;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;EAEE,eAAe,yBAAyB;EACxC,aAAa;EACb,mBAAmB,CAAC;;EAEpB;IACE,gBAAgB;IAGhB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;IACxC,kBAAkB,CAAC","sourcesContent":["\n/* Card */\n.card {\n    margin-bottom: 30px;\n    border: none;\n    border-radius: 5px;\n    box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);\n  }\n  \n  .card-header,\n  .card-footer {\n    border-color: #ebeef4;\n    background-color: #fff;\n    color: #798eb3;\n    padding: 15px;\n  }\n  \n  .user-webnexs .card-title {\n    padding: 20px 0 15px 0;\n    font-size: 18px;\n    font-weight: 500;\n    color: #000000;\n    font-family: \"Poppins\", sans-serif;\n  }\n\n  .user-webnexs span.small.pt-1.fw-bold {\n    color: black;\n}\n  \n  .card-title span {\n    color: #899bbd;\n    font-size: 14px;\n    font-weight: 400;\n  }\n  \n  .card-body {\n    padding: 0 20px 20px 20px;\n  }\n  \n  .card-img-overlay {\n    background-color: rgba(255, 255, 255, 0.6);\n  }\n  \n  .dashboard .nav-link{\n    border-radius: 5px;\n    border-bottom: 1px solid #e9e6e6;\n    font-weight: 500;\n    color: #000000;\n    background-color: #e1e1e1;\n  }\n\n  .dashboard .nav-link.active {\n    background: rgb(255 255 255 / 20%);\n    font-size: 16px;\n    font-weight: 500;\n    color: #000;\n}\n\n  .upload-video {background-color: #fafafa;\n  padding: 10px;\n  border-radius: 10px;}\n\n  .iq-card {\n    background: #fff;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    border-radius: 5px;\n    margin-bottom: 30px;\n    border: none;\n    box-shadow: 0px 4px 20px rgb(0 0 0 / 5%);\n    border-radius: 5px;}\n\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
